import { render, staticRenderFns } from "./autoSlides.vue?vue&type=template&id=f44c9540&"
import script from "./autoSlides.vue?vue&type=script&lang=js&"
export * from "./autoSlides.vue?vue&type=script&lang=js&"
import style0 from "./autoSlides.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "autoSlides.vue"
export default component.exports